import { createStyles, Grid, makeStyles, Typography } from '@material-ui/core';
import { Button, Dialog, i18n, Icons } from '@nutrien/cxp-components';
import React from 'react';

interface Props {
  onClose: () => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    dialogContent: {
      padding: '8px !important',
    },
    content: {
      marginTop: 7,
    },
  }),
);

const MissingPanelDrawingDialog: React.FC<Props> = ({ onClose }: Props) => {
  const classes = useStyles();

  return (
    <Dialog
      open
      titleText={i18n.t('Missing panel drawing')}
      backButton={false}
      disableEnforceFocus
      onClose={onClose}
      maxWidth="xs"
      maxHeight="225px"
      dialogContentClassName={classes.dialogContent}
      BackdropProps={{
        onClick: event => {
          event.preventDefault();
        },
        onTouchStart: event => {
          event.preventDefault();
        },
        style: { touchAction: 'none' },
      }}
      dialogActions={
        <Grid container justify="flex-end" spacing={2}>
          <Grid item xs={4}>
            <Button
              onClick={onClose}
              variant="contained"
              color="primary"
              noMinHeight
              id="redirect-panel-drawing-button"
            >
              {i18n.t('Ok')}
            </Button>
          </Grid>
        </Grid>
      }
    >
      <Grid container justify="center" alignItems="center" className={classes.content}>
        <Grid item xs={1}>
          <Icons.InfoFeather color="error" />
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body1">
            {i18n.t(
              'Missing panel drawing for this shift. Please close the previous shift or add a new panel drawing on the area check screen',
            )}
          </Typography>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default MissingPanelDrawingDialog;
